import React, { useEffect } from 'react'
import BigAd from '../components/BigAd'
import Brands from '../components/Brands'
import Collection from '../components/Collection'
import Find from '../components/Find'
import Highlights from '../components/Highlights'
import PopularSearch from '../components/PopularSearch'
import Recommended from '../components/Recommended'
import RunningShoes from '../components/RunningShoes'
import { HomePath } from '../home-path'
import Median from 'median-js-bridge';

import { products } from '../data'

export default function Shop() {
  if (!localStorage.getItem('reloadGN')) {
    localStorage.setItem('reloadGN', 'true');
    window.location.reload();
  }

  useEffect(() => {
    if (window.navigator.userAgent.indexOf("gonative") !== -1) {
      const username = 'gonative';
      const password = 'password';

      function gonative_status_afterlogin(data) {
        if (data && data.hasTouchId) {
          var secret = {
            username: username,
            password: password
          };
          Median.auth.save({ 'secret': secret });
        }
      }

      Median.auth.status({ 'callbackFunction': gonative_status_afterlogin });
    }
  });

  return (
    <div>
        <Highlights products={products} />
        <RunningShoes products={products} />
        <BigAd route={HomePath + "/shop"} minorHeading="Member exclusive sale" majorHeading="SAVE UP TO 50%" text="Lorem ipsum dolor sit amet ipsum dolor sit amet"  buttonText="Shop" />
        <Collection products={products} />
        <Brands products={products} />
        <PopularSearch />
        <Recommended products={products} />
        <Find />
        <BigAd route={HomePath + "/shop"} minorHeading="Discounted prices today" majorHeading="Big sale for limited time!" text="Lorem ipsum dolor sit amet ipsum dolor sit amet" buttonText="Shop sale!" />
    </div>
  )
}
